var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('section',{attrs:{"id":"mcKinsey-startup-accelerator"}},[_c('br'),_c('br'),_c('figure',{staticClass:"image is-16by9"},[_c('iframe',{staticClass:"has-ratio",attrs:{"width":"640","height":"360","src":"https://www.youtube.com/embed/D_JdhtsD-n8?showinfo=0","frameborder":"0","allowfullscreen":""}})]),_c('br')])
}]

export { render, staticRenderFns }